import { Checkbox } from '@zoopla-eng/zds/checkbox';
import { Stack } from '@zoopla-eng/zds/stack';
import { checkboxContainerStyle } from './Modal.styles.css';

export type BuyerIncentive = '' | 'help_to_buy';
export type ChainFree = 'true' | '';
export type ReducedPrice = 'true' | '';
export type IncludeSold = 'true' | '';

export type PropertyStatus = {
    buyerIncentive: BuyerIncentive;
    chainFree: ChainFree;
    reducedPrice: ReducedPrice;
    includeSold: IncludeSold;
};

type PropertyStatusProps = {
    value: PropertyStatus;
    onChange: (propertyStatus: PropertyStatus) => void;
};

export const PropertyStatus = ({ value, onChange }: PropertyStatusProps) => {
    return (
        <Stack
            flexDirection="row"
            flexWrap="wrap"
            // columnGap="0"
            rowGap="S400"
        >
            <div className={checkboxContainerStyle}>
                <Checkbox
                    name="chain_free"
                    label="Chain-free"
                    checked={value.chainFree === 'true'}
                    onCheckedChange={(checked) => {
                        onChange({
                            ...value,
                            chainFree: checked ? 'true' : ''
                        });
                    }}
                />
            </div>
            <div className={checkboxContainerStyle}>
                <Checkbox
                    name="reduced_price"
                    label="Price-reduced"
                    checked={value.reducedPrice === 'true'}
                    onCheckedChange={(checked) => {
                        onChange({
                            ...value,
                            reducedPrice: checked ? 'true' : ''
                        });
                    }}
                />
            </div>
            <div className={checkboxContainerStyle}>
                <Checkbox
                    name="include_sold"
                    label="Under offer/Sold STC"
                    checked={value.includeSold === 'true'}
                    onCheckedChange={(checked) => {
                        onChange({
                            ...value,
                            includeSold: checked ? 'true' : ''
                        });
                    }}
                />
            </div>
        </Stack>
    );
};
